module.exports = __webpack_public_path__ + "static/media/arbutus-269-min.b6b760b8.jpg";